// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jobwidget-layout__body{display:block;background-color:#f5f7fa}.jobwidget-layout__body__content{padding-top:0;min-height:0}@media (max-width:767.98px){.jobwidget-layout__body__content{min-height:0}}", ""]);
// Exports
module.exports = exports;
